import React from 'react';
import { Space, Typography, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import Modal from './Modal';

const { Title, Text, Paragraph } = Typography;

const InfoModal = ({
  open,
  onClose,
  title = 'Informações',
  content,
  details,
  footer,
  showCloseButton = true,
  closeText = 'Fechar',
  width = 480,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <Modal
      title={
        <Space>
          <InfoCircleOutlined style={{ fontSize: '20px', color: theme.primary }} />
          <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
            {title}
          </Title>
        </Space>
      }
      open={open}
      onCancel={onClose}
      variant="info"
      width={width}
      showOkButton={false}
      showCancelButton={showCloseButton}
      cancelText={closeText}
      footer={footer}
      {...props}
    >
      <div style={{ padding: '8px 0' }}>
        {/* Conteúdo principal */}
        {content && (
          <div style={{ marginBottom: details ? 16 : 0 }}>
            {typeof content === 'string' ? (
              <Paragraph style={{ fontSize: '15px', lineHeight: '1.6', margin: 0 }}>
                {content}
              </Paragraph>
            ) : (
              content
            )}
          </div>
        )}

        {/* Divisor se houver conteúdo e detalhes */}
        {content && details && (
          <Divider style={{ margin: '16px 0' }} />
        )}

        {/* Detalhes adicionais */}
        {details && (
          <div>
            {Array.isArray(details) ? (
              details.map((detail, index) => (
                <div key={index} style={{ marginBottom: index < details.length - 1 ? 12 : 0 }}>
                  {typeof detail === 'object' && detail.label ? (
                    <div>
                      <Text strong style={{ display: 'block', marginBottom: 4 }}>
                        {detail.label}:
                      </Text>
                      <Text>{detail.value}</Text>
                    </div>
                  ) : (
                    <Text>{detail}</Text>
                  )}
                </div>
              ))
            ) : (
              <div>{details}</div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default InfoModal; 